/**
 * @documental
 * @export Placeholder
 * @name
 * Textbox.Placeholder
 */

import { FC } from "react";
import Skeleton from "react-loading-skeleton";
import { BaseProps } from "../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { Body } from "capitalrx-components-2.0/lib/typography";
import { Shared } from "capitalrx-components-2.0/lib/forms";
import TextboxStyles from "capitalrx-components-2.0/lib/forms/Textbox/styles.module.scss";

/**
 * The `Placeholder` component properties.
 */

export interface PlaceholderProps extends BaseProps {}

/**
 * A loading placeholder for the `Textbox` component.
 */
export const Placeholder: FC<PlaceholderProps> = (props) => {
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [TextboxStyles.TextboxPlaceholder, "textbox", "placeholder"],
    testIdPrefix: "textbox",
  });

  return (
    <Shared.InputContainerPlaceholder {...getBasePropsFromHtmlProps(baseHtmlProps)}>
      <Body className="input-container">
        <Skeleton />
      </Body>
    </Shared.InputContainerPlaceholder>
  );
};
